export default "__VITE_ASSET__CpOj7fRt__"